interface Data {
    [key: string]: Cell;
};

interface Cell {
    _: string;
}

export const convertToObject=(keys: string[], values: Cell[][]): Data[] => {
    
    //Repace spaces with underscore
    const transformedKeys = keys.map(key => key.replace(/\s+/g, '_'));

    return values.map(row => {
        const obj: Data = {};
        transformedKeys.forEach((key, index) => {
            obj[key] = row[index];
        });
        return obj;

    });
}